import React from 'react'
import PortableText from 'components/indy/shared/PortableText'

export const SanityBlock = ({ children, ...rest }) => (
  <PortableText blocks={children} {...rest} />
)
export default SanityBlock
